export default __webpack_public_path__ + "static/media/undraw_Gift_card_re_5dyy.00cca9a2.svg";